<template>
    <div class="w-100">
        <div
            v-if="showWarning"
            class="mb-3 fw-bold">
            {{ renameNote }}
        </div>
        <pc-input
            id="NewNameInput"
            v-model="newName"
            v-bind:class="{ 'mt-3': showWarning }"
            v-bind:label="labelLoc"
            v-bind:maxlength="maxlength"
            data-test-role="new-name-input" />
        <div
            v-if="!newName"
            class="alert alert-danger mt-3 mb-0">
            {{ emptyLabelWarningLoc }}
        </div>
        <div
            v-if="error"
            class="alert alert-danger mt-3 mb-0">
            {{ error }}
        </div>
    </div>
</template>
<script>
    import { KEYS, NAMESPACE } from "./i18n/nameEntryModal.i18n";
    import { mapI18n } from "Util/i18n";

    export const NAME_ENTRY_RESULT = {
        save: "Save",
        cancel: "Cancel"
    };
    export default {
        props: {
            name: { type: String, required: true },
            label: { type: String, required: false, default: null },
            showWarning: { type: Boolean, required: false, default: true },
            invalidNames: { type: Array, required: false, default: () => [] },
            invalidCharacters: { type: Array, required: false, default: () => [] },
            invalidWhitespace: { type: Boolean, required: false, default: false },
            enforceExtension: { type: Boolean, required: false, default: false },
            maxlength: { type: Number, required: false, default: null }
        },
        data() {
            return {
                requestData: this.data,
                newName: this.name,
                extension: this.getExtension(this.name),
                error: null
            };
        },
        computed: {
            labelLoc() {
                return this.label ?? this.labelDefault;
            },
            ...mapI18n(
                {
                    ...KEYS,
                    emptyLabelWarningLoc() {
                        return {
                            key: KEYS.emptyLabelWarning,
                            values: { labelText: this.labelLoc }
                        };
                    }
                },
                NAMESPACE
            )
        },
        watch: {
            newName() {
                this.error = null;
            }
        },
        methods: {
            async saveAndVerify(dialogResult) {
                if (dialogResult === NAME_ENTRY_RESULT.save) {
                    if (!this.newName) {
                        return false;
                    } else if (this.invalidNames.includes(this.resultHook().toLowerCase())) {
                        this.error = this.duplicateNameError;
                        return false;
                    }
                    if (this.invalidWhitespace && /\s/.test(this.newName)) {
                        this.error = this.whitespaceError;
                        return false;
                    }
                    if (this.invalidCharacters.length > 0) {
                        const found = this.invalidCharacters.filter((c) => this.newName.indexOf(c) >= 0);
                        if (found.length > 0) {
                            this.error = this.res({
                                namespace: NAMESPACE,
                                key: KEYS.invalidCharacterError,
                                values: { characterList: found.join(", ") }
                            });
                            return false;
                        }
                    }
                    if (this.enforceExtension) {
                        const newExtension = this.getExtension(this.newName);
                        if (this.extension.toLowerCase() != newExtension.toLowerCase()) {
                            if (!this.extension) {
                                this.error = this.fileExtensionNotAllowedError;
                            } else {
                                this.error = this.newExtensionError;
                            }
                            return false;
                        }
                    }
                }
                return true;
            },
            getExtension(name) {
                let extension = "";
                if (name.indexOf(".") >= 0) {
                    extension = name.substring(name.lastIndexOf("."));
                }
                return extension;
            },
            resultHook() {
                return this.newName;
            }
        }
    };
</script>
